export default __webpack_public_path__ + "static/amenagement-galerie-a6705fae89c203ff73715c835dd6f832.png";